import React from "react";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import clsx from "clsx";
import styles from "./rowSettings.module.scss";

function RowSettings({
  form: {
    codeSchool,
    membershipToPay,
    isUnCompleted,
    isDeceased,
    sequence,
    presidentRole,
    recurringPayment,
    recurringPeriodicity,
    recurringDate,
  },
  handleForm,
  handleFormCheckbox,
  isAspiring,
  recurringError,
}) {
  return (
    <div>
      <div className={styles.top_row_setting}>
        {!isAspiring ? (
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isUnCompleted}
                  onChange={handleFormCheckbox}
                  name="isUnCompleted"
                />
              }
              label="Incompleto"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={isDeceased}
                  onChange={handleFormCheckbox}
                  name="isDeceased"
                />
              }
              label="Fallecido"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={presidentRole}
                  onChange={handleFormCheckbox}
                  name="presidentRole"
                />
              }
              label="Role de presidente"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={recurringPayment}
                  onChange={handleFormCheckbox}
                  name="recurringPayment"
                />
              }
              label="Pago recurrentes"
            />
          </div>
        ) : null}
        <div className="top_row_setting__info">
          <TextField
            name="codeSchool"
            value={codeSchool}
            label="Código Colegio"
            margin="normal"
            fullWidth
            onChange={handleForm}
          />
          <TextField
            name="sequence"
            value={sequence}
            label="No. Miembro"
            margin="normal"
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            className={clsx(styles.inputMedium, styles.inputRightSpace)}
          />
          <TextField
            name="membershipToPay"
            value={membershipToPay}
            label="Membresía pendientes"
            margin="normal"
            fullWidth
            onChange={handleForm}
            type="number"
            readOnly
          />
        </div>
      </div>
      {
        recurringPayment ? (<div className={styles.recurringForm}>
        <TextField
          name="recurringPeriodicity"
          value={recurringPeriodicity}
          label="Periocidad en meses"
          margin="normal"
          fullWidth
          onChange={handleForm}
          className={styles.inputRightSpace}
          type="number"
        />
        <TextField
          id="recurringDate"
          label="Fecha de cobro"
          type="date"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          fullWidth
          name="recurringDate"
          value={
            Date.parse(recurringDate)
              ? new Date(recurringDate).toISOString().slice(0, 10)
              : ""
          }
          onChange={handleForm}
          error={recurringError}
          className={styles.inputMedium}
        />
      </div>) : null
      }
    </div>
  );
}

RowSettings.defaultProps = {
  recurringError: false,
};

export default RowSettings;
